import React from "react";

export default class TableCentricPageButton extends React.Component {
  handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault(); // Prevent default scrolling behavior for Space
      this.props.onClickHandler(event);
    }
  };

  render() {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <a
        data-cy={this.props["data-cy"]}
        className="heading_button"
        onClick={this.props.onClickHandler}
        onKeyDown={this.handleKeyDown}
        tabIndex={0}
        role="button"
        aria-label={this.props.title}
      >
        {this.props.title}
      </a>
    );
  }
}
